export const DRAGABBLE_FRAMES_SLICE = 'DRAGABBLE_FRAMES_SLICE';
